export function generateName() {
  const length = 5;

  return Math.random()
    .toString(36)
    .substring(2, 2 + length);
}

export function pickRandomFromArray<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function buildGameUrl(code: string | number) {
  return `${location.protocol}//${location.host}/${encodeURIComponent(code.toString())}`;
}

export function uuid() {
  return Math.random().toString(36).substring(2);
}
